const htmlBlockSchema = {
  title: 'HTML Block Settings',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
    {
      id: 'external_resources',
      title: 'External Resources',
      fields: ['externalScripts', 'externalStyles'],
    },
  ],
  properties: {
    externalScripts: {
      title: 'External Scripts',
      description: 'Add external script URLs (one per line)',
      widget: 'textarea',
    },
    externalStyles: {
      title: 'External Stylesheets',
      description: 'Add external stylesheet URLs (one per line)',
      widget: 'textarea',
    },
  },
  required: [],
};

export default htmlBlockSchema;
